import { makeStyles } from '@material-ui/core/styles';

const welcomeMessageStyles = makeStyles(
  ({ palette, spacing, breakpoints }) => ({
    contentWrapper: {
      zIndex: 10,
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [breakpoints.down('sm')]: {
        display: 'block !important',
        '& > *': {
          display: 'block',
        },
      },
    },
    pageTitle: {
      color: palette.primary.contrastText,
      margin: `${spacing(0, 2, 0, 0)} !important`,
    },
  }),
  { name: 'WelcomeMessage' },
);

export default welcomeMessageStyles;
